module.exports = __webpack_public_path__ + "img/aertuerk.f6feb383.png";